import { useEffect, useState } from "react";

type BackToTopProps = {
  isProfile?: boolean;
};

function BackToTop({ isProfile = false }: BackToTopProps) {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      setIsVisible(window.scrollY > 200);
    };

    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleClick = () => {
    window.dispatchEvent(new Event("nav-clear"));
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const colorClass = isProfile
    ? "bg-blue-400 shadow-blue-400/25 hover:shadow-blue-400/35 focus-visible:outline-blue-400"
    : "bg-red-400 shadow-red-400/25 hover:shadow-red-400/35 focus-visible:outline-red-400";

  return (
    <button
      type="button"
      onClick={handleClick}
      aria-label="ページトップへ戻る"
      className={`fixed bottom-5 right-5 z-40 rounded-full ${colorClass} p-3 text-white shadow-lg ring-1 ring-white/60 transition-all duration-200 hover:-translate-y-1 hover:shadow-xl focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 md:bottom-8 md:right-8 ${
        isVisible ? "opacity-100" : "pointer-events-none opacity-0"
      }`}
    >
      <span className="flex h-8 w-8 flex-col items-center justify-center gap-0.5 text-[11px] font-semibold leading-none">
        <i className="ri-arrow-up-line text-lg" aria-hidden="true"></i>
        <span>TOP</span>
      </span>
    </button>
  );
}

export default BackToTop;
